import { useNavigate } from "react-router-dom";
import { FileText, Shield, ArrowLeft } from "lucide-react";
import "./pages.css";

const PAGES = [
  {
    path: "/pages/terms",
    icon: FileText,
    title: "Terms & Conditions",
    description: "Subscription terms, refund policy, acceptable use, and governing law.",
    updated: "July 2025",
  },
  {
    path: "/pages/privacy",
    icon: Shield,
    title: "Privacy Policy",
    description: "How we collect, use, store, and protect your data.",
    updated: "July 2025",
  },
];

export default function PagesIndex() {
  const navigate = useNavigate();

  return (
    <div className="pages-page">
      <div className="pages-index-header">
        <button className="pages-toc-back" onClick={() => navigate("/")}>
          <ArrowLeft size={13} /> Back
        </button>
        <h1 className="pages-title">Documents &amp; Policies</h1>
        <p className="pages-meta">VisuN AI Employee Monitoring</p>
      </div>

      <div className="pages-index-grid">
        {PAGES.map(({ path, icon: Icon, title, description, updated }) => (
          <button
            key={path}
            className="pages-index-card"
            onClick={() => navigate(path)}
          >
            <div className="pages-index-card-icon">
              <Icon size={22} />
            </div>
            <div className="pages-index-card-body">
              <h2 className="pages-index-card-title">{title}</h2>
              <p className="pages-index-card-desc">{description}</p>
            </div>
            <span className="pages-index-card-meta">Updated {updated}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
